import { VisuallyHidden } from "radix-ui"

/**
 * A label that is hidden visually but still accessible to screen readers
 * and automated translation services.
 *
 * "aria-label" is not translated by automated translation services and should
 * be avoided in favor of "HiddenLabel" component.
 *
 * @see https://adrianroselli.com/2019/11/aria-label-does-not-translate.html
 */
export function HiddenLabel(props: VisuallyHidden.VisuallyHiddenProps) {
  return <VisuallyHidden.Root {...props} />
}
